import { createSlice } from '@reduxjs/toolkit';
import {
    fetchWorkingTimes,
    createWorkingTime,
    updateWorkingTime,
    deleteWorkingTime,
} from '../thunks/workingTimeThunks.js';

const initialState = {
    list: [],
    loading: false,
    isCreating: false,
    error: null,
};

const workingTimeSlice = createSlice({
    name: 'workingTime',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWorkingTimes.fulfilled, (state, action) => {
                Object.assign(state, action.payload);
                state.loading = false;
            })
            .addCase(createWorkingTime.fulfilled, (state, action) => {
                state.list.unshift(action.payload);
                state.loading = false;
            })
            .addCase(deleteWorkingTime.fulfilled, (state, action) => {
                state.list = state.list.filter(({ id }) => id !== action.payload.id);
                state.loading = false;
            })
            .addCase(updateWorkingTime.fulfilled, (state, action) => {
                const updated = action.payload;
                state.list = state.list.map((w) => (w.id === updated.id ? updated : w));
                state.loading = false;
            })
            .addMatcher(
                (action) =>
                    [
                        fetchWorkingTimes.pending.type,
                        createWorkingTime.pending.type,
                        updateWorkingTime.pending.type,
                        deleteWorkingTime.pending.type,
                    ].includes(action.type),
                (state) => {
                    state.loading = true;
                    state.error = null;
                },
            )
            .addMatcher(
                (action) =>
                    [
                        fetchWorkingTimes.rejected.type,
                        createWorkingTime.rejected.type,
                        updateWorkingTime.rejected.type,
                        deleteWorkingTime.rejected.type,
                    ].includes(action.type),
                (state, action) => {
                    state.loading = false;
                    state.error = action.error?.message || action.payload;
                },
            )
            .addDefaultCase((state) => state);
    },
});

export default workingTimeSlice.reducer;
